<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<elder-basic-pane-layout class="full">
  <elder-pane appFacilityContext (facilityChange)="facility = $event">
    <div class="layout-row full">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="layoutTab">
        <mat-tab label="Graph">
          <ng-template matTabContent>
            <app-shopfloor-layout-graph
              class="flex"
              [context]="context$ | async"
              [spec]="spec$ | async"
              (nodeClicked)="onNodeClicked($event)"
              (edgeClicked)="onEdgeClicked($event)"
            ></app-shopfloor-layout-graph>
          </ng-template>
        </mat-tab>

        <mat-tab label="{{ 'layout.list' | translate }}">
          <app-shopfloor-layout-editor
            class="flex"
            [spec]="spec$ | async"
            [context]="context$ | async"
            (specChanged)="onSpecChange($event)"
          ></app-shopfloor-layout-editor>
        </mat-tab>
      </mat-tab-group>

      <div class="flex-none layout-col">
        <button
          mat-icon-button
          matBadge="!"
          matBadgeOverlap="true"
          matBadgePosition="above before"
          matBadgeSize="large"
          matBadgeColor="warn"
          [matBadgeHidden]="!(pendingChanges$ | async)"
          [disabled]="!(pendingChanges$ | async)"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </div>
  </elder-pane>
</elder-basic-pane-layout>
